// extracted by mini-css-extract-plugin
module.exports = {"placeholder-image":"styles_placeholder-image__a9jTS"};